<div class="content-page">
  <div class="quickorder-content">
    <ish-breadcrumb />
    <div class="row">
      <div class="col-md-12">
        <h1>{{ 'dias.quickorder.page.title' | translate }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <ng-container *ngIf="isLoggedIn$ | async">
          <custom-quickorder-order-template-list [orderTemplates]="orderTemplates$ | async" />
        </ng-container>
      </div>
    </div>
    <custom-quickorder-upload />
    <custom-quickorder-add-products-form />
    <!-- <ish-loading *ngIf="loading$ | async"></ish-loading> -->
  </div>
</div>
